<template>
  <router-view />

  <Modal />
</template>

<script setup>
import { onMounted } from 'vue'
import { authIsAdmin, disableContextMenu } from './services/auth'
import { useAuthStore } from './store/auth'

import Modal from './components/common/Modal.vue'

const authStore = useAuthStore()

onMounted(() => {
  disableContextMenu(authIsAdmin())
  authStore.loadUserFromLocalStorage()
})
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>
